export { Appstore } from './Appstore';
export { ArrowHouse } from './ArrowHouse';
export { Atm } from './Atm';
export { BubbleClose } from './BubbleClose';
export { BubbleIconSmall } from './BubbleIconSmall';
export { Calendar } from './Calendar';
export { CalendarIconLarge } from './CalendarIconLarge';
export { CheckboxActive } from './CheckboxActive';
export { Clock } from './Clock';
export { Close } from './Close';
export { CloseIcon } from './CloseIcon';
export { Datepicker } from './Datepicker';
export { ElectricCar } from './ElectricCar';
export { ExpandPlus } from './ExpandPlus';
export { Facebook } from './Facebook';
export { GasCar } from './GasCar';
export { GoBackArrow } from './GoBackArrow';
export { Headset } from './Headset';
export { House } from './House';
export { HybridCar } from './HybridCar';
export { Info } from './Info';
export { Language } from './Language';
export { Lock } from './Lock';
export { Ludur } from './Ludur';
export { PlayStore } from './PlayStore';
export { Question } from './Question';
export { ScrollDownArrow } from './ScrollDownArrow';
export { CancelContract } from './CancelContract';
export { SearchIcon } from './Search';
export { Service } from './Service';
export { Share } from './Share';
export { Skutla } from './Skutla';
export { SkutlaLarge } from './SkutlaLarge';
export { SmileIcon } from './SmileIcon';
export { Web } from './Web';
export { Mail } from './Mail';
export { Twitter } from './Twitter';
export { Arrow } from './arrows/Arrow';
export { ArrowDown } from './arrows/ArrowDown';
export { SimpleArrow } from './arrows/SimpleArrow';

export { AirContract } from './points/AirContract';
export { Bicycle } from './points/Bicycle';
export { Car } from './points/Car';
export { ElectonicCar } from './points/ElectonicCar';
export { Food } from './points/Food';
export { Foot } from './points/Foot';
export { Paper } from './points/Paper';
export { Pcaf } from './points/Pcaf';

export { Phone } from './tiles/Phone';
export { Visa } from './tiles/Visa';
export { Tree } from './tiles/Tree';
export { NotFound } from './NotFound';

export { Username } from './authentication/Username';
export { ElectronicId } from './authentication/ElectronicId';
export { FaceId } from './authentication/FaceId';
export { Fingerprint } from './authentication/Fingerprint';
export { Pin } from './authentication/Pin';
import React from 'react';
import { Anaegjuvogin } from './arsskyrsla/Anaegjuvogin';
import { FyrstaSaeti } from './arsskyrsla/FyrstaSaeti';
import { Greidslumat } from './arsskyrsla/Greidslumat';
import { NewDocument } from './arsskyrsla/NewDocument';
import { Sjalfsafgreidsla } from './arsskyrsla/Sjalfsafgreidsla';
import { Timapantanir } from './arsskyrsla/Timapantanir';
import { Atm } from './Atm';
import { Clock } from './Clock';
import { DownArrow } from './DownArrow';
import { Facebook } from './Facebook';
import { Bilalan } from './homepage/Bilalan';
import { Fyrirtaeki } from './homepage/Fyrirtaeki';
export { Fyrirtaeki };
import { Ibudalan } from './homepage/Ibudalan';
import { Kreditkort } from './homepage/Kreditkort';
import { Radgjof } from './homepage/Radgjof';
import { Sereignasparnadur } from './homepage/Sereignasparnadur';
import { Sparnadur } from './homepage/Sparnadur';
import { Info } from './Info';
import { Contract } from './points/Contract';
import { Document } from './points/Document';
import { Invoice } from './points/Invoice';
import { Wallet } from './points/Wallet';
import { HouseLine } from './related/HouseLine';
import { Service } from './Service';
import { Airwaves } from './tiles/Airwaves';
import { IcelandAirwaves } from './tiles/IcelandAirwaves';
import { LandsbankinnIcon } from './tiles/Landsbankinn';
import { Phone } from './tiles/Phone';
import { BlueSpotify } from './tiles/Spotify';
import { Tree } from './tiles/Tree';
import { Visa } from './tiles/Visa';
import { BlueYoutube } from './tiles/Youtube';
import { Twitter } from './Twitter';
import { Web } from './Web';
import { Youtube } from './Youtube';

interface IProps {
  name: string;
}

const icons = {
  facebook: <Facebook />,
  youtube: <Youtube />,
  twitter: <Twitter />,
  house: <HouseLine />,
  contract: <Contract />,
  document: <Document />,
  invoice: <Invoice />,
  wallet: <Wallet />,
  ibudalan: <Ibudalan />,
  bilalan: <Bilalan />,
  sparnadur: <Sparnadur />,
  serignasparnadur: <Sereignasparnadur />,
  kreditkort: <Kreditkort />,
  radgjof: <Radgjof />,
  atm: <Atm />,
  service: <Service />,
  clock: <Clock />,
  downarrow: <DownArrow />,
  web: <Web />,
  visa: <Visa />,
  info: <Info />,
  anaegjuvogin: <Anaegjuvogin />,
  fyrstasaeti: <FyrstaSaeti />,
  sjalfsafgreidsla: <Sjalfsafgreidsla />,
  greidslumat: <Greidslumat />,
  timapantanir: <Timapantanir />,
  downloaddocument: <NewDocument />,
  phone: <Phone />,
  tree: <Tree />,
  bluespotify: <BlueSpotify />,
  blueyoutube: <BlueYoutube />,
  icelandairwaves: <IcelandAirwaves />,
  airwaves: <Airwaves />,
  landsbankinn: <LandsbankinnIcon />,
  fyrirtaeki: <Fyrirtaeki />,
};

export const Icon = ({ name }: IProps) => {
  return icons[name?.toLocaleLowerCase()] || null;
};
